unit View.data_base.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewdata_baseEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbtoken: TLabel;
    edtoken: TDBEdit;
    lbfiscal: TLabel;
    edfiscal: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientdata_baseGet: TXDataWebClient;
    XDataClientdata_baseDelete: TXDataWebClient;
    data_baseDataset: TXDataWebDataSet;
    data_baseDatasetid: TIntegerField;
    data_baseDatasettoken: TStringField;
    data_baseDatasetfiscal: TBooleanField;
    data_baseDatasetaliado_id: TIntegerField;
    data_baseDatasetexcluido: TBooleanField;
    data_baseDatasetinclusao: TDateTimeField;
    data_baseDatasetalteracao: TDateTimeField;
    data_baseDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientdata_baseGetLoad(Response: TXDataClientResponse);
    procedure XDataClientdata_baseDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientdata_baseDeleteError(Error: TXDataClientError);
    procedure data_baseDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewdata_baseEdit: TFViewdata_baseEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewdata_baseEdit }

procedure TFViewdata_baseEdit.btSaveClick(Sender: TObject);
begin
  if data_baseDataset.State in dsEditModes then
  begin
        data_baseDataset.Post;
    data_baseDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewdata_baseEdit.btDeleteClick(Sender: TObject);
begin
  if data_baseDataset.State in dsEditModes then
    data_baseDataset.Post;
  XDataClientdata_baseDelete.Delete(data_baseDataset.EntitySetName,
    TJSObject(data_baseDataset.CurrentData));
end;


class function TFViewdata_baseEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewdata_baseEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewdata_baseEdit.InsertEntity;
begin
  data_baseDataset.Close;
  data_baseDataset.SetJsonData('{}');
  data_baseDataset.Open;
  data_baseDataset.Insert;
end;

class function TFViewdata_baseEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewdata_baseEdit(AForm).FInserting := AInserting;
    TFViewdata_baseEdit(AForm).FId := AId;
    TFViewdata_baseEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewdata_baseEdit(AForm).InsertEntity
    else
      TFViewdata_baseEdit(AForm).LoadEntity;
    TFViewdata_baseEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewdata_baseEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewdata_baseEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    data_baseDataset.Connection.Model.DefaultSchema.FindEntityType(
      data_baseDataset.EntitySetName
    )
  );
  XDataClientdata_baseGet.Get(data_baseDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewdata_baseEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewdata_baseEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewdata_baseEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewdata_baseEdit.XDataClientdata_baseGetLoad(Response: TXDataClientResponse);
begin
  data_baseDataset.Close;
  data_baseDataset.SetJsonData(Response.Result);
  data_baseDataset.Open;
  
  data_baseDataset.Edit;  
end;

procedure TFViewdata_baseEdit.XDataClientdata_baseDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewdata_baseEdit.XDataClientdata_baseDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewdata_baseEdit.data_baseDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewdata_baseEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewdata_baseEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.data_base.form.message');
  lbMessage := TLabel.Create('view.data_base.form.message.label');
  btCloseMessage := TButton.Create('view.data_base.form.message.button');
  btCancel := TButton.Create('view.data_base.form.btBack');
  btSave := TButton.Create('view.data_base.form.btSave');
  btDelete := TButton.Create('view.data_base.form.btDelete');
  lbid := TLabel.Create('view.data_base.form.lbid');
  edid := TDBEdit.Create('view.data_base.form.edid');
  lbtoken := TLabel.Create('view.data_base.form.lbtoken');
  edtoken := TDBEdit.Create('view.data_base.form.edtoken');
  lbfiscal := TLabel.Create('view.data_base.form.lbfiscal');
  edfiscal := TDBEdit.Create('view.data_base.form.edfiscal');
  lbaliado_id := TLabel.Create('view.data_base.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.data_base.form.edaliado_id');
  lbexcluido := TLabel.Create('view.data_base.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.data_base.form.edexcluido');
  lbinclusao := TLabel.Create('view.data_base.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.data_base.form.edinclusao');
  lbalteracao := TLabel.Create('view.data_base.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.data_base.form.edalteracao');
  lbexclusao := TLabel.Create('view.data_base.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.data_base.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  data_baseDataset := TXDataWebDataSet.Create(Self);
  data_baseDatasetid := TIntegerField.Create(Self);
  data_baseDatasettoken := TStringField.Create(Self);
  data_baseDatasetfiscal := TBooleanField.Create(Self);
  data_baseDatasetaliado_id := TIntegerField.Create(Self);
  data_baseDatasetexcluido := TBooleanField.Create(Self);
  data_baseDatasetinclusao := TDateTimeField.Create(Self);
  data_baseDatasetalteracao := TDateTimeField.Create(Self);
  data_baseDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientdata_baseGet := TXDataWebClient.Create(Self);
  XDataClientdata_baseDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbtoken.BeforeLoadDFMValues;
  edtoken.BeforeLoadDFMValues;
  lbfiscal.BeforeLoadDFMValues;
  edfiscal.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  data_baseDataset.BeforeLoadDFMValues;
  data_baseDatasetid.BeforeLoadDFMValues;
  data_baseDatasettoken.BeforeLoadDFMValues;
  data_baseDatasetfiscal.BeforeLoadDFMValues;
  data_baseDatasetaliado_id.BeforeLoadDFMValues;
  data_baseDatasetexcluido.BeforeLoadDFMValues;
  data_baseDatasetinclusao.BeforeLoadDFMValues;
  data_baseDatasetalteracao.BeforeLoadDFMValues;
  data_baseDatasetexclusao.BeforeLoadDFMValues;
  XDataClientdata_baseGet.BeforeLoadDFMValues;
  XDataClientdata_baseDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewdata_baseEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 481;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 421;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 421;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 421;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbtoken.SetParentComponent(Self);
    lbtoken.Name := 'lbtoken';
    lbtoken.Left := 24;
    lbtoken.Top := 219;
    lbtoken.Width := 14;
    lbtoken.Height := 13;
    lbtoken.Caption := 'token:';
    lbtoken.Transparent := True;
    edtoken.SetParentComponent(Self);
    edtoken.Name := 'edtoken';
    edtoken.Left := 221;
    edtoken.Top := 216;
    edtoken.Width := 200;
    edtoken.Height := 21;
    edtoken.Enabled := True;
    edtoken.TabOrder := 7;
    edtoken.Text := 'edtoken';
    edtoken.DataField := 'token';
    edtoken.DataSource := DataSource;
    lbfiscal.SetParentComponent(Self);
    lbfiscal.Name := 'lbfiscal';
    lbfiscal.Left := 24;
    lbfiscal.Top := 246;
    lbfiscal.Width := 14;
    lbfiscal.Height := 13;
    lbfiscal.Caption := 'fiscal:';
    lbfiscal.Transparent := True;
    edfiscal.SetParentComponent(Self);
    edfiscal.Name := 'edfiscal';
    edfiscal.Left := 221;
    edfiscal.Top := 243;
    edfiscal.Width := 200;
    edfiscal.Height := 21;
    edfiscal.Enabled := True;
    edfiscal.TabOrder := 8;
    edfiscal.Text := 'edfiscal';
    edfiscal.DataField := 'fiscal';
    edfiscal.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 273;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 270;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 9;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 300;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 297;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 10;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 327;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 324;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 11;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 354;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 351;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 12;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 381;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 378;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 13;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := data_baseDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    data_baseDataset.SetParentComponent(Self);
    data_baseDataset.Name := 'data_baseDataset';
    data_baseDataset.AfterApplyUpdates := data_baseDatasetAfterApplyUpdates;
    data_baseDataset.EntitySetName := 'data_base';
    data_baseDataset.Connection := DMConnection.ApiConnection;
    data_baseDataset.Left := 176;
    data_baseDataset.Top := 8;
    data_baseDatasetid.SetParentComponent(data_baseDataset);
    data_baseDatasetid.Name := 'data_baseDatasetid';
    data_baseDatasetid.FieldName := 'id';
    data_baseDatasetid.Required := True;
    data_baseDatasettoken.SetParentComponent(data_baseDataset);
    data_baseDatasettoken.Name := 'data_baseDatasettoken';
    data_baseDatasettoken.FieldName := 'token';
    data_baseDatasettoken.Required := True;
    data_baseDatasettoken.Size := 256;
    data_baseDatasetfiscal.SetParentComponent(data_baseDataset);
    data_baseDatasetfiscal.Name := 'data_baseDatasetfiscal';
    data_baseDatasetfiscal.FieldName := 'fiscal';
    data_baseDatasetfiscal.Required := True;
    data_baseDatasetaliado_id.SetParentComponent(data_baseDataset);
    data_baseDatasetaliado_id.Name := 'data_baseDatasetaliado_id';
    data_baseDatasetaliado_id.FieldName := 'aliado_id';
    data_baseDatasetaliado_id.Required := True;
    data_baseDatasetexcluido.SetParentComponent(data_baseDataset);
    data_baseDatasetexcluido.Name := 'data_baseDatasetexcluido';
    data_baseDatasetexcluido.FieldName := 'excluido';
    data_baseDatasetexcluido.Required := False;
    data_baseDatasetinclusao.SetParentComponent(data_baseDataset);
    data_baseDatasetinclusao.Name := 'data_baseDatasetinclusao';
    data_baseDatasetinclusao.FieldName := 'inclusao';
    data_baseDatasetinclusao.Required := False;
    data_baseDatasetalteracao.SetParentComponent(data_baseDataset);
    data_baseDatasetalteracao.Name := 'data_baseDatasetalteracao';
    data_baseDatasetalteracao.FieldName := 'alteracao';
    data_baseDatasetalteracao.Required := False;
    data_baseDatasetexclusao.SetParentComponent(data_baseDataset);
    data_baseDatasetexclusao.Name := 'data_baseDatasetexclusao';
    data_baseDatasetexclusao.FieldName := 'exclusao';
    data_baseDatasetexclusao.Required := False;
    XDataClientdata_baseGet.SetParentComponent(Self);
    XDataClientdata_baseGet.Name := 'XDataClientdata_baseGet';
    XDataClientdata_baseGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientdata_baseGet, Self, 'OnLoad', 'XDataClientdata_baseGetLoad');
    XDataClientdata_baseGet.Left := 64;
    XDataClientdata_baseGet.Top := 8;
    XDataClientdata_baseDelete.SetParentComponent(Self);
    XDataClientdata_baseDelete.Name := 'XDataClientdata_baseDelete';
    XDataClientdata_baseDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientdata_baseDelete, Self, 'OnLoad', 'XDataClientdata_baseDeleteLoad');
    SetEvent(XDataClientdata_baseDelete, Self, 'OnError', 'XDataClientdata_baseDeleteError');
    XDataClientdata_baseDelete.Left := 64;
    XDataClientdata_baseDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbtoken.AfterLoadDFMValues;
    edtoken.AfterLoadDFMValues;
    lbfiscal.AfterLoadDFMValues;
    edfiscal.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    data_baseDataset.AfterLoadDFMValues;
    data_baseDatasetid.AfterLoadDFMValues;
    data_baseDatasettoken.AfterLoadDFMValues;
    data_baseDatasetfiscal.AfterLoadDFMValues;
    data_baseDatasetaliado_id.AfterLoadDFMValues;
    data_baseDatasetexcluido.AfterLoadDFMValues;
    data_baseDatasetinclusao.AfterLoadDFMValues;
    data_baseDatasetalteracao.AfterLoadDFMValues;
    data_baseDatasetexclusao.AfterLoadDFMValues;
    XDataClientdata_baseGet.AfterLoadDFMValues;
    XDataClientdata_baseDelete.AfterLoadDFMValues;
  end;
end;

end.
